import { SYSTEM_ERROR } from "../config/CONSTANT";
import axios from "axios";
import packageJson from "../../package.json";
import * as sweetalert from "sweetalert";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const getAllCities = () => {
  return new Promise((resolve, reject) => {
    try {
    
          axios
            .get(
              `${BaseUrl}/api/country/1/cities`,
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              axios.defaults.headers.common["X-CSRF-TOKEN"] = res;

              resolve(res.data);
            })

            .catch((err) => {
                if (err.res && err.res.status === 500) {
                  sweetalert(err.res.msg, {
                    className: "alert-div",
                    button: {
                      text: "تم",
                    },
                  });
                }
              });
        
    } 
    catch (error) {
      console.error("in tripServices > getAllTrips, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};
